import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsDelete.vue?vue&type=template&id=cc745d5a&scoped=true&"
import script from "./MonthAllowancesPlanDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc745d5a",
  null
  
)

export default component.exports